import { OhsUser } from 'user/OhsUser';
import { getWorkplaceOptions } from 'user/OhsUserServices';

export enum OhsSafetyPlanViewPresets {
  View1SafetyPlanList = 'view1safetyPlanList',
  View2SafetyPlanList = 'view2safetyPlanList',
  View3SafetyPlanList = 'view3safetyPlanList',
  View1SafetyPlanSchedList = 'view1safetyPlanScheduledList',
  View2SafetyPlanSchedList = 'view2safetyPlanScheduledList',
  View1SafetyPlanHistoryList = 'view1SafetyPlanHistoryList',
}

export default class OhsSafetyPlanFilterModels {
  [OhsSafetyPlanViewPresets.View1SafetyPlanList]: {
    viewPreset: 'view_1';
    categories?: string[];
    subcategories?: string[];
    archived?: boolean;
    sort: string;
  };

  [OhsSafetyPlanViewPresets.View2SafetyPlanList]: {
    viewPreset: 'view_2';
    categories?: string[];
    subcategories?: string[];
    workplaces?: string[];
    archived?: boolean;
    allocatedToOrg?: boolean;
    allocatedToWorkplace?: boolean;
    notAllocated?: boolean;
    workplaceOwned?: boolean;
    sort: string;
  };

  [OhsSafetyPlanViewPresets.View3SafetyPlanList]: {
    viewPreset: 'view_3';
    categories?: string[];
    subcategories?: string[];
    archived?: boolean;
    allocatedToWorkplace?: boolean;
    workplaceOwned?: boolean;
    sort: string;
  };

  [OhsSafetyPlanViewPresets.View1SafetyPlanSchedList]: {
    viewPreset: 'view_1';
    archived?: boolean;
    categories?: string[];
    subcategories?: string[];
    workplaces?: string[];
    allocatedToOrg?: boolean;
    workplaceOwned?: boolean;
    allocatedToWorkplace?: boolean;
    dateDue?: { start: string; end: string };
    sort: string;
  };

  [OhsSafetyPlanViewPresets.View2SafetyPlanSchedList]: {
    viewPreset: 'view_2';
    archived?: boolean;
    categories?: string[];
    subcategories?: string[];
    allocatedToWorkplace?: boolean;
    workplaceOwned?: boolean;
    dateDue?: { start: string; end: string };
    sort: string;
  };

  [OhsSafetyPlanViewPresets.View1SafetyPlanHistoryList]: {
    workplaces?: string[];
    sort: string;
    archived?: boolean;
  };

  dateDue?: { start: string; end: string };

  dateCompleted?: { start: string; end: string };

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
    sortScheduledColAscDescOptions: { name: string; value: string }[];
    sortHistoryOptions: { name: string; value: string }[];
  };

  constructor(user?: OhsUser, tabKey?: string | null) {
    this[OhsSafetyPlanViewPresets.View1SafetyPlanList] = {
      viewPreset: 'view_1',
      categories: [],
      subcategories: [],
      archived: false,
      sort: '{ "key": "_id", "order": 1 }',
    };
    this[OhsSafetyPlanViewPresets.View2SafetyPlanList] = {
      viewPreset: 'view_2',
      categories: [],
      subcategories: [],
      workplaces: [],
      archived: false,
      allocatedToOrg: true,
      allocatedToWorkplace: true,
      notAllocated: true,
      workplaceOwned: true,
      sort: '{ "key": "name", "order": 1 }',
    };
    this[OhsSafetyPlanViewPresets.View3SafetyPlanList] = {
      viewPreset: 'view_3',
      categories: [],
      subcategories: [],
      archived: false,
      allocatedToWorkplace: true,
      workplaceOwned: true,
      sort: '{ "key": "name", "order": 1 }',
    };
    this[OhsSafetyPlanViewPresets.View1SafetyPlanSchedList] = {
      viewPreset: 'view_1',
      archived: false,
      categories: [],
      subcategories: [],
      workplaces: [],
      allocatedToOrg: true,
      workplaceOwned: true,
      allocatedToWorkplace: true,
      dateDue: undefined,
      sort:
        user?.tierNum === 1 ? '{ "key": "_id", "order": 1 }' : '{ "key": "dateDue", "order": 1 }',
    };
    this[OhsSafetyPlanViewPresets.View2SafetyPlanSchedList] = {
      viewPreset: 'view_2',
      archived: false,
      categories: [],
      subcategories: [],
      allocatedToWorkplace: true,
      workplaceOwned: true,
      dateDue: undefined,
      sort: '{ "key": "dateDue", "order": 1 }',
    };

    this[OhsSafetyPlanViewPresets.View1SafetyPlanHistoryList] = {
      workplaces: [],
      sort: '{ "key": "dateSignedoff", "order": -1 }',
    };

    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'Name: A to Z', value: '{ "key": "name", "order": 1 }' },
        { name: 'Name: Z to A', value: '{ "key": "name", "order": -1 }' },
        { name: 'Category: A to Z', value: '{ "key": "category", "order": 1 }' },
        { name: 'Category: Z to A', value: '{ "key": "category", "order": -1 }' },
        { name: 'Date Created: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Date Created: Oldest to Newest', value: '{ "key": "_id", "order": 1 }' },
      ],
      sortScheduledColAscDescOptions: [
        { name: 'Due Date: Newest to Oldest', value: '{ "key": "dateDue", "order": -1 }' },
        { name: 'Due Date: Oldest to Newest', value: '{ "key": "dateDue", "order": 1 }' },
        { name: 'Date Created: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Date Created: Oldest to Newest', value: '{ "key": "_id", "order": 1 }' },
      ],
      sortHistoryOptions: [
        { name: 'Sign Off: Newest to Oldest', value: '{ "key": "dateSignedoff", "order": -1 }' },
        { name: 'Sign Off: Oldest to Newest', value: '{ "key": "dateSignedoff", "order": 1 }' },
        { name: 'Date Created: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Date Created: Oldest to Newest ', value: '{ "key": "_id", "order": 1 }' },
      ],
    };

    if (user && tabKey) {
      const getWorkplaceLists = getWorkplaceOptions(user.configs);
      const workplaceOptions = getWorkplaceLists.map((list: any) => list.id);

      this[OhsSafetyPlanViewPresets.View2SafetyPlanList] = {
        ...this[OhsSafetyPlanViewPresets.View2SafetyPlanList],
        workplaces: workplaceOptions,
      };

      this[OhsSafetyPlanViewPresets.View1SafetyPlanSchedList] = {
        ...this[OhsSafetyPlanViewPresets.View1SafetyPlanSchedList],
        workplaces: workplaceOptions,
      };
    }
  }
}
